import React from "react";
import "./CookiePolicy.css";
const CookiePolicy = () => {
  return (
    <div className="cookiePolicy_parent_div">
      <h1>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Itaque nemo
        inventore omnis molestiae mollitia dolores reiciendis rem esse vel natus
        ullam voluptatem, quod adipisci enim dicta quam deserunt voluptates
        facere?
      </h1>
    </div>
  );
};

export default CookiePolicy;
